import Header from '../components/Header';
import Footer from '../components/Footer';

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="font-serif text-xl text-white font-bold mb-3">{title}</h2>
    <div className="text-white/75 text-sm leading-relaxed space-y-3">{children}</div>
  </section>
);

export default function TermsOfUsePage() {
  return (
    <div className="min-h-screen relative">
      <div className="fixed inset-0 -z-10 bg-gradient-to-br from-ocean via-ocean-light/90 to-sky/70" />
      <Header />
      <main className="pt-24 pb-20 px-4 sm:px-6 md:px-12 lg:px-24">
        <div className="max-w-3xl mx-auto bg-white/10 backdrop-blur-xl border border-white/15 rounded-2xl p-6 sm:p-10" data-testid="terms-of-use-page">
          <h1 className="font-serif text-3xl text-white font-bold mb-2">Terms of Use</h1>
          <p className="text-white/50 text-sm mb-8">Last updated: April 2026</p>

          <Section title="1. Acceptable Use">
            <p>You agree to use Triple A Travel Solutions only for lawful purposes related to travel planning and booking. You must not:</p>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>Attempt to gain unauthorised access to other accounts or our systems</li>
              <li>Use automated tools to scrape, crawl, or extract data from our platform</li>
              <li>Upload malicious content, spam, or inappropriate material</li>
              <li>Misrepresent your identity or provide false information</li>
              <li>Use the Service for any commercial purpose without our written consent</li>
            </ul>
          </Section>

          <Section title="2. Account Responsibilities">
            <p>You are solely responsible for your account security. You must immediately notify us if you suspect any unauthorised use of your account. Triple A Travel Solutions is not liable for losses resulting from unauthorised account access due to your failure to safeguard your credentials.</p>
          </Section>

          <Section title="3. Intellectual Property">
            <p>All content on the Triple A Travel Solutions platform — including the website design, logos, text, AI-generated itineraries, and software — is the intellectual property of Triple A Travel Solutions or its licensors. You may not reproduce, distribute, or create derivative works from our content without prior written permission.</p>
            <p>Content you upload (photos, reviews) remains your property. By uploading, you grant us a non-exclusive licence to display this content within the platform and in aggregated review showcases.</p>
          </Section>

          <Section title="4. User-Generated Content">
            <p>You are responsible for content you submit, including reviews and photos. You must not post content that is defamatory, offensive, misleading, or infringes on third-party rights. We reserve the right to remove content that violates these terms without notice.</p>
          </Section>

          <Section title="5. Service Availability">
            <p>We strive to maintain 24/7 availability but do not guarantee uninterrupted access. The Service may be temporarily unavailable due to maintenance, updates, or factors beyond our control. We are not liable for any loss resulting from service interruptions.</p>
          </Section>

          <Section title="6. Limitation of Liability">
            <p>To the maximum extent permitted by law, Triple A Travel Solutions, its directors, employees, and agents shall not be liable for any direct, indirect, incidental, special, or consequential damages arising from your use of the Service.</p>
            <p>Our total liability for any claim shall not exceed the amount you paid to Triple A Travel Solutions in the twelve months preceding the claim.</p>
          </Section>

          <Section title="7. Indemnification">
            <p>You agree to indemnify and hold harmless Triple A Travel Solutions from any claims, damages, or expenses arising from your use of the Service, your violation of these Terms, or your infringement of any third-party rights.</p>
          </Section>

          <Section title="8. Governing Law">
            <p>These Terms are governed by and construed in accordance with the laws of Australia. Any disputes arising from these Terms shall be subject to the exclusive jurisdiction of the courts of Australia.</p>
          </Section>

          <Section title="9. Contact">
            <p>For questions about these Terms of Use, contact us at <a href="mailto:triplea@tripleabooking.com" className="text-gold hover:underline">triplea@tripleabooking.com</a> or call +61 401 050 457.</p>
          </Section>
        </div>
      </main>
    </div>
  );
}
